import { Outlet } from 'react-router-dom';
import { Header } from './Header';
import type { User } from '@supabase/supabase-js';

interface AppLayoutProps {
  user: User | null;
}

export const AppLayout = ({ user }: AppLayoutProps) => {
  return (
    <>
      <Header user={user} />
      <main className="pt-16 min-h-screen bg-gray-50">
        <Outlet />
      </main>
    </>
  );
};
